exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".room_color {\n  background: none;\n  border: 0px;\n  padding: 0px;\n  width: 25px;\n  height: 30px;\n  cursor: pointer; }\n\n.invalid-feedback {\n  display: none;\n  padding: .2em .6em .3em;\n  font-size: 75%;\n  font-weight: 700;\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: .25em;\n  color: #fff;\n  background: #E15554; }\n\n.was-validated .invalid-feedback {\n  display: inline; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/modal-room-group/modal-room-group.component.scss
// module id = ../../../../../src/app/components/modal-room-group/modal-room-group.component.scss
// module chunks = main